import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Hook reutilizable que detecta el idioma desde la URL y lo aplica automáticamente
 * Funciona con:
 * 1. Rutas con parámetro :lang (ca, es, en)
 * 2. Rutas con prefijo de idioma /es/, /ca/, /en/
 */
const useLanguageFromUrl = () => {
    const { lang } = useParams();
    const location = useLocation();
    const { language, changeLanguage, availableLanguages } = useLanguage();

    useEffect(() => {
        let detectedLang = lang;

        // Si no hay parámetro :lang, intentar detectar desde el pathname
        if (!detectedLang) {
            const pathname = location.pathname;

            // Detectar idioma desde el prefijo del path (/es/, /ca/, /en/)
            const pathParts = pathname.split('/').filter(Boolean);
            if (pathParts.length > 0) {
                const firstPart = pathParts[0];
                if (availableLanguages.includes(firstPart)) {
                    detectedLang = firstPart;
                }
            }
        }

        // Si hay un idioma detectado y es válido, aplicarlo
        if (detectedLang && availableLanguages.includes(detectedLang) && detectedLang !== language) {
            console.log(`[Language] Changing language from URL: ${detectedLang}`);
            changeLanguage(detectedLang);
        }
    }, [lang, location.pathname, language, changeLanguage, availableLanguages]);

    return {
        urlLanguage: lang,
        currentLanguage: language,
        isLanguageFromUrl: !!lang
    };
};

export default useLanguageFromUrl;

